module.exports = __webpack_public_path__ + "img/ButtonThree.6bb560a9.svg";